export default __webpack_public_path__ + "static/media/mShoes_1.eab00fcd.bin";